import React from "react";
const CurrencyMapping = ({ programFee, programFeeTitle, currentSiteMeta }) => {
  const currencyToUse = currentSiteMeta?.currency
    ? currentSiteMeta.currency.toLowerCase()
    : process.env.GATSBY_PROJECT_CURRENCY ?? "usd";

  const programFeeAmount =
    programFee.find(
      (amount) => amount[`${programFeeTitle}Currency`] === currencyToUse
    ) ?? [];

  const currencyAmount = programFeeAmount[`${programFeeTitle}Amount`] ?? 0;

  const currencyFromAmount =
    programFeeAmount[`${programFeeTitle}FromAmount`] ?? 0;
  const currencyToAmount = programFeeAmount[`${programFeeTitle}ToAmount`] ?? 0;

  const currencyFormat = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency:
      currentSiteMeta?.currency ?? process.env.GATSBY_PROJECT_CURRENCY ?? "usd",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currencyDisplay: "code"
  });

  const currencyFormatAmount =
    currencyAmount && currencyAmount > 0
      ? currencyFormat.format(currencyAmount)
      : currencyFromAmount > 0
      ? `${currencyFormat.format(currencyFromAmount)} - ${currencyFormat.format(
          currencyToAmount
        )}`
      : 0;

  const currencyAmountDisplay = currencyFormatAmount.replaceAll(
    currentSiteMeta?.currency,
    currentSiteMeta?.currency_symbol
  );

  return <span dangerouslySetInnerHTML={{ __html: currencyAmountDisplay }} />;
};

export default CurrencyMapping;
